import React from 'react'
import CardSummary from './CardSummary'

interface CardDeckProps {
    /** Total number of devices currently loaded */
    devicesCount: number
    /** Number of devices whose last-seen status is not 'ok' */
    failureCount: number
    /** Number of devices with an active oil alarm */
    oilAlarmCount: number
}

/**
 * Row of three summary cards shown at the top of the devices list page.
 *
 * Displays active-device count, failure count, and oil-shortage count.
 */
const CardDeck = ({
    devicesCount,
    failureCount,
    oilAlarmCount,
}: CardDeckProps) => {
    return (
        <div className="card-deck mt-5 mt-md-0">
            <CardSummary
                title="activeDevices"
                color="success"
                // linkText="show"
            >
                {devicesCount}
            </CardSummary>
            <CardSummary
                title="failure"
                color="danger"
                // linkText="show"
            >
                {failureCount}
            </CardSummary>
            <CardSummary
                title="oilShortage"
                color="warning"
                // linkText="show"
            >
                {oilAlarmCount}
            </CardSummary>
        </div>
    )
}

export default CardDeck
